import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Portfolio from "./components/Portfolio.js";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    const checkBackendConnection = async () => {
      try {
        const response = await axios.get(`${API}/`, { timeout: 10000 });
        console.log("✅ Backend connected:", response.data.message);
      } catch (e) {
        console.warn("⚠️ Backend connection failed:", e.message);
        console.log("Backend URL:", `${API}/`);
        console.log("Make sure backend is running on http://localhost:8001");
      }
    };

    checkBackendConnection();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

//finished frontend